var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form-select-remote-search',_vm._g(_vm._b({attrs:{"key-text":"name","key-value":"id","url":'/api/location?' + _vm.filter,"search-url":'/api/location?' + _vm.filter + '&q='}},'form-select-remote-search',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }